// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___3665025d179367dacf8{/*!*/}.SimplePaperPodcast-cls2__c11556e939492ce788a2{color:#d1d5db;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___3665025d179367dacf8",
	"cls2": "SimplePaperPodcast-cls2__c11556e939492ce788a2 SimplePaperPodcast-cls1___3665025d179367dacf8"
};
export default ___CSS_LOADER_EXPORT___;
